'use client';
import React, { Fragment, ReactNode, useEffect, useState } from 'react';
import styles from './styles.module.css';
import { setState } from '@/commonTypes';
import Button from '@/components/common/Button';
import MainIcons from '@/icons/main';
import { useTranslations } from 'next-intl';
import { usePathname, useRouter, useSearchParams } from 'next/navigation';
import { useRouterPath } from '@/functions/routerPath';
import Api from '@/api';
import ViewportWrapper from '@/components/structure/ViewportWrapper';
import NotFoundBox from '../NotFoundBox';

export default function InfiniteContent({
  page,
  params,
  initialList,
  list,
  setList,
  limit,
  apiCall = Api.categoryList,
  renderItem,
  urlQuery = false,
  pageNumber,
  setPageNumber,
  gridClass = '',
  children,
  showEmpty = true,
  clearButton = false,
  callBackList,
  itemClass = '',
  emptyText,
  wrapperClass = '',
}: {
  page?: string | number | null;
  params: any;
  initialList?: any;
  list?: any;
  setList: setState<any>;
  limit: number;
  apiCall?: any;
  renderItem: (item: any, index: number) => React.ReactNode;
  urlQuery?: boolean;
  pageNumber: string | number;
  setPageNumber: setState<string | number>;
  gridClass?: string;
  children?: ReactNode;
  showEmpty?: boolean;
  clearButton?: boolean;
  callBackList?: (x?: any) => void;
  itemClass?: string;
  emptyText?: string;
  wrapperClass?: string;
}) {
  const tCommon = useTranslations('common');
  const searchParams = useSearchParams();
  // const [pageNumber, setPageNumber] = useState(page ? page : 1);
  //   const [list, setList] = useState(initialList);

  // useEffect(() => {
  //   setPageNumber(page ? page : 1);
  // }, [page]);
  useEffect(() => {}, [initialList]);
  console.log('pageNumber==', pageNumber);
  const router = useRouter();
  const routerPath = useRouterPath();
  const pathname = usePathname();
  const getMorePost = (increase: number, more: boolean) => {
    const urlParams = new URLSearchParams(searchParams.toString());

    const name = urlParams.get('name');
    urlParams.delete('name');

    let newPath = pathname;

    if (!urlQuery) {
      newPath = newPath.replace(/\/page\/\d+$/, '');

      if (name && !newPath.includes(`/name/${name}`)) {
        newPath += `/${encodeURIComponent(name)}`;
      }

      newPath += `/page/${Number(pageNumber) + increase}`;
    } else {
      urlParams.set('page', `${Number(pageNumber) + increase}`);
    }
    const query = urlParams.toString();

    if (more) {
      window.history.pushState({}, '', `${newPath}${query ? `?${query}` : ''}`);
      const apiparams = Object.fromEntries(params);

      console.log('apiparams========', apiparams);
      apiCall({ params: { ...apiparams, start: list?.response?.length } })
        .then((res: any) => {
          let response = { ...res?.data };
          if (more) {
            response = { ...res?.data, response: list?.response?.concat(res?.data?.response) };
          }
          callBackList ? callBackList(res?.data?.response) : setList(response);
          setPageNumber(Number(pageNumber) + 1);
        })
        .catch((err: any) => {
          console.error('InfiniteContent fetch failed:', err);
        });
    } else {
      router.push(`${newPath}${query ? `?${query}` : ''}`, {
        scroll: false,
      });
    }
  };
  console.log('page==', page, pageNumber, limit, initialList?.response_details?.count);
  return (
    <div className={`${styles.posts} ${wrapperClass}`}>
      <div
        className={`${styles.posts_grid} ${gridClass} ${list?.response?.length == 0 && 'emptyGrid'}`}
      >
        {list?.response?.map((item: any, index: number) => (
          <ViewportWrapper key={item.id ?? index} delay={(index + 1) * 0.07} className={itemClass}>
            {renderItem(item, index)}
          </ViewportWrapper>
        ))}
        {children}
        {showEmpty && list?.response?.length == 0 && (
          // <p>{tCommon('emptyList')}</p>
          <NotFoundBox clearButton={clearButton} text={emptyText} />
        )}
      </div>
      {page != null ? (
        <div className={`${styles.buttonContainer}`}>
          {Number(page) > 1 && (
            <Button
              className={`btn-white squareButton cursor-pointer`}
              onClick={() => getMorePost(-1, false)}
            >
              <MainIcons.arrowIcon />
              {tCommon('previousPage')}
            </Button>
          )}
          {Number(pageNumber) * limit < Number(initialList?.response_details?.count) && (
            <Button
              className={`btn-white squareButton cursor-pointer`}
              onClick={() => getMorePost(1, false)}
            >
              {tCommon('nextPage')}
              <MainIcons.arrowIcon className={`${styles.rotate180}`} />
            </Button>
          )}
        </div>
      ) : (
        <>
          {Number(pageNumber) * limit < Number(initialList?.response_details?.count) && (
            <Button
              wrapperStyle={`${styles.parentButton} `}
              className={`btn-white squareButton cursor-pointer`}
              onClick={() => getMorePost(1, true)}
            >
              {tCommon('viewMore')}
              <MainIcons.arrowIcon className={`${styles.rotate}`} />
            </Button>
          )}
        </>
      )}
    </div>
  );
}
